import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: 'mdi',
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#CCFF99', // LIME
                secondary: '#66CCCC', // SKY BLUE
                accent: '#03342C', // GREEN
                backGroundPrimary: '#333333', // DARK DARK
                backGroundSecondary: '#666666', // LIGHT GREY
            },
        },
    },
    icons: {
        values: {
            account: {component: () => import('@/components/icons/account')},
            account_circle: {component: () => import('@/components/icons/account_circle')},
            account_multiple: {component: () => import('@/components/icons/account_multiple')},
            calendar: {component: () => import('@/components/icons/calendar')},
            home: {component: () => import('@/components/icons/home')},
            statistics: {component: () => import('@/components/icons/statistics')},
            logout: {component: () => import('@/components/icons/logout')},
            add_circle: {component: () => import('@/components/icons/add_circle')},
            copy: {component: () => import('@/components/icons/copy')},
            edit: {component: () => import('@/components/icons/edit')},
            save: {component: () => import('@/components/icons/save')},
            training: {component: () => import('@/components/icons/training')},
            left_arrow: {component: () => import('@/components/icons/left_arrow')},
            right_arrow: {component: () => import('@/components/icons/right_arrow')},
            dots_vertical: {component: () => import('@/components/icons/dots_vertical')},
            lock: {component: () => import('@/components/icons/lock')},
            delete: {component: () => import('@/components/icons/delete')},
            vacations: {component: () => import('@/components/icons/vacations')},
            injury: {component: () => import('@/components/icons/injury')},
            company: {component: () => import('@/components/icons/company')},
            search: {component: () => import('@/components/icons/search')},
            check: {component: () => import('@/components/icons/check')},
            close: {component: () => import('@/components/icons/close')},
            upload_image: {component: () => import('@/components/icons/upload_image')},
            strong: {component: () => import('@/components/icons/strong')},
            speed: {component: () => import('@/components/icons/speed')},
            mobility: {component: () => import('@/components/icons/mobility')},
            stability: {component: () => import('@/components/icons/stability')},
            resistance: {component: () => import('@/components/icons/resistance')},
            hypertrophy: {component: () => import('@/components/icons/hypertrophy')},
            power: {component: () => import('@/components/icons/power')},
            circuit: {component: () => import('@/components/icons/circuit')},
            myofascial_relaxation: {component: () => import('@/components/icons/myofascial_relaxation')},
            activity: {component: () => import('@/components/icons/activity')},
            stability2: {component: () => import('@/components/icons/stability2')},
            painScale: {component: () => import('@/components/icons/painScale')},
        }
    }
});
